import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconChevron.module.css';

const IconChevron = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.6 3.90582L0 0.305824L0.305823 0L3.6 3.294L6.89418 0L7.2 0.305824L3.6 3.90582Z" fill="#1C1B1F"/>
    </svg>
  );
};

const { string } = PropTypes;

IconChevron.defaultProps = {
  className: null,
  rootClassName: null,
};

IconChevron.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconChevron;
